const PAYMENTS_AND_INVOICES_PATH = '/platnosci-i-faktury';

export const getPaymentsAndInvoicesPath = (): string => PAYMENTS_AND_INVOICES_PATH;
